module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/doubt-4f07e2c4.png";